import React from 'react';

export default function SessionDetailModal({
  sessionId,
  sessionDetail,
  stationSkills,
  availableSkills,
  onClose,
  onCheckIn,
  onStartSession,
  onAssignSkill,
  onStartSkillTest,
  onLoadSkillDetail,
  onCompleteSkillTest,
  onReturnToStaging,
  onCompleteSession
}) {
  if (!sessionId || !sessionDetail) return null;

  return (
    <div
      className="modal-overlay"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'rgba(0,0,0,0.5)',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <div
        className="modal-content"
        style={{
          background: '#fff',
          borderRadius: 12,
          padding: 24,
          minWidth: 500,
          maxWidth: 700,
          maxHeight: '80vh',
          overflow: 'auto',
          boxShadow: '0 4px 24px rgba(0,0,0,0.2)',
          position: 'relative'
        }}
      >
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: 12,
            right: 16,
            fontSize: 24,
            background: 'none',
            border: 'none',
            cursor: 'pointer'
          }}
        >
          ✕
        </button>

        <h3 style={{ marginBottom: 16 }}>
          📋 Session: {sessionDetail.company_name} at {sessionDetail.station_name}
        </h3>

        <div style={{ marginBottom: 16, padding: '12px', background: '#f8f9fa', borderRadius: 8 }}>
          <div><strong>Status:</strong> {sessionDetail.status}</div>
          <div><strong>Mode:</strong> {sessionDetail.testing_mode}</div>
          <div><strong>Skill Selection:</strong> {sessionDetail.skill_selection_mode}</div>
        </div>

        <div style={{ marginBottom: 16, display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <button className="btn" onClick={() => onCheckIn(sessionId)} style={{ background: '#e8f5e9' }}>
            ✓ Check In
          </button>
          <button className="btn" onClick={() => onStartSession(sessionId)} style={{ background: '#e3f2fd' }}>
            ▶️ Start Testing
          </button>
        </div>

        <h4>Candidates ({sessionDetail.candidates?.length || 0})</h4>
        <div style={{ marginBottom: 16 }}>
          {sessionDetail.candidates?.map((candidate) => (
            <div
              key={candidate.id}
              style={{
                padding: '8px 12px',
                background: '#f8f9fa',
                borderRadius: 6,
                marginBottom: 8,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}
            >
              <div>
                <strong>{candidate.first_name} {candidate.last_name}</strong>
                <span style={{ marginLeft: 12, color: '#666' }}>ID: {candidate.candidate_id}</span>
              </div>
              <select
                onChange={(e) => {
                  if (e.target.value) {
                    onAssignSkill(sessionId, candidate.id, parseInt(e.target.value));
                    e.target.value = '';
                  }
                }}
                style={{ padding: '4px 8px', borderRadius: 4 }}
              >
                <option value="">+ Assign Skill</option>
                {(stationSkills[sessionDetail.station_id] || availableSkills).map((skill) => (
                  <option key={skill.skill_id || skill.id} value={skill.skill_id || skill.id}>
                    {skill.skill_name || skill.name}
                  </option>
                ))}
              </select>
            </div>
          ))}
        </div>

        <h4>Skill Assignments</h4>
        <div style={{ marginBottom: 16 }}>
          {sessionDetail.skill_assignments?.length === 0 ? (
            <div style={{ color: '#888', padding: 8 }}>
              No skills assigned yet. Use the dropdown above to assign skills.
            </div>
          ) : (
            sessionDetail.skill_assignments?.map((assignment) => (
              <div
                key={assignment.id}
                style={{
                  padding: '12px',
                  background:
                    assignment.result === 'pass'
                      ? '#d4edda'
                      : assignment.result === 'fail'
                        ? '#f8d7da'
                        : '#fff3cd',
                  borderRadius: 6,
                  marginBottom: 8,
                  border: '1px solid #dee2e6'
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
                  <div>
                    <strong>{assignment.skill_name}</strong>
                    <div style={{ fontSize: '0.85em', color: '#666' }}>
                      Candidate:{' '}
                      {sessionDetail.candidates?.find((c) => c.id === assignment.candidate_id)?.last_name || 'Unknown'}
                      {assignment.started_at && !assignment.completed_at && ' • ⏱️ In Progress'}
                      {assignment.completed_at && ` • ${assignment.result?.toUpperCase()}`}
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                    {!assignment.started_at && (
                      <button className="btn" onClick={() => onStartSkillTest(sessionId, assignment.id)}>
                        ▶️ Start
                      </button>
                    )}
                    {assignment.started_at && !assignment.completed_at && (
                      <>
                        <button className="btn" onClick={() => onLoadSkillDetail(assignment.skill_id, assignment.id)}>
                          📝 Checklist
                        </button>
                        <button className="btn pass" onClick={() => onCompleteSkillTest(sessionId, assignment.id, 'pass')}>
                          ✅ Pass
                        </button>
                        <button className="btn fail" onClick={() => onCompleteSkillTest(sessionId, assignment.id, 'fail')}>
                          ❌ Fail
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

        <div style={{ display: 'flex', gap: 12, marginTop: 24, borderTop: '1px solid #dee2e6', paddingTop: 16 }}>
          <button className="btn" onClick={() => onReturnToStaging(sessionId)} style={{ background: '#f8d7da' }}>
            ↩️ Return to Staging
          </button>
          <button className="btn" onClick={() => onCompleteSession(sessionId)} style={{ background: '#d4edda' }}>
            ✓ Complete Session
          </button>
        </div>
      </div>
    </div>
  );
}
